<template>
  <div class="subscribAaudit">
    <!-- 订阅审核页面 -->
    <h3>审核详情</h3>
    <el-row> 
      <el-form class="registeredForm" :model="reportList">
          <!-- 时间 -->
        <el-form-item>
          <div style="width: 100%">提交时间:</div>
          <el-input
             disabled
            v-model="reportList.time"
            size="small"
            autocomplete="off"  
            style="width: 14.5%"
            :placeholder="$t(`login.placeholderTitle`)"
          ></el-input>
        </el-form-item>
        <!-- 报告类型 -->
        <el-form-item>
          <div style="width: 100%">报告类型:</div>
          <el-input
             disabled
            v-model="reportList.type"
            size="small"
            autocomplete="off"  
            style="width: 14.5%"
            :placeholder="$t(`login.placeholderTitle`)"
          ></el-input>
        </el-form-item>
        <!-- 报告者-->
        <el-form-item>
          <div style="width: 100%">报告者:</div>
          <el-input
            disabled
            v-model="reportList.people"
            size="small"
            autocomplete="off"
            style="width: 14.5%"
            :placeholder="$t(`login.placeholderTitle`)"
          ></el-input>
        </el-form-item>
        <!-- 报告计划发出日期和时间-->
        <el-form-item class="accountUpgrade">
          <div style="width: 100%">报告计划发出日期和时间:</div>

          <el-input
             disabled
            v-model="reportList.time"
            size="small"
            autocomplete="off"  
            style="width: 14.5%"
            :placeholder="$t(`login.placeholderTitle`)"
          ></el-input>
        </el-form-item>
        <!--报告标题-->
        <el-form-item>
          <div style="width: 100%">报告标题:</div>
          <el-input
           disabled
            v-model="reportList.title"
            size="small"
            autocomplete="off"
            style="width: 30%"
            :placeholder="$t(`login.placeholderTitle`)"
          ></el-input>
        </el-form-item>
        <!-- 报告内容-->
        <el-form-item>
          <div style="width: 100%">报告内容:</div>
          <!-- :autosize="{ minRows: 10, maxRows: 10}" -->
     

          <el-input
          disabled
            type="textarea"
            style="width: 60%"
            resize="none"
            v-model="reportList.content"
            :autosize="{ minRows: 5, maxRows: 10}"
          ></el-input>
        </el-form-item>
          <!--审核意见-->
        <el-form-item>
          <div style="width: 100%">审核意见:</div>   
          <el-input     
            type="textarea"
            style="width: 60%"
            resize="none"
             :placeholder="$t(`login.placeholderTitle`)"
            v-model="reportList.content"
            :autosize="{ minRows: 5, maxRows: 10}"
          ></el-input>
        </el-form-item>

        <el-button type="warning" style="width:160px">接受</el-button>
         <el-button type="warning" style="width:160px">拒绝</el-button>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "../subscribAaudit/index";
export default {
  mixins: [IndexJs],
};
</script>

<style lang="scss" scoped>
.subscribAaudit {
  // outline: 1px solid red;
  padding: 50px 20px;
  .subscribeDetails {
    color: rgba(0, 0, 0, 0.6);
    //  outline: 1px solid red;
    width: 100%;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .subscribeCheckbox {
      display: flex;
      // outline: 1px solid red;
    }
  }
}

// -----------移动平均线--------------------
.period:hover {
  border: 1px solid rgba(0, 0, 0, 0.8);
}
.period {
  // padding-left: 10px;
  // position: absolute;
  // top: 2px;
  // right: 237px;
  // background: #f5921a;
  // padding: 0px 5px;
  height: 30px;
  // width: 400px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  // margin-right: 5px;
  // .SMATitle {
  //   // outline: 1px solid  red;
  //   padding-right: 5px;
  //   height: 30px;
  //   line-height: 28px;
  //   font-size: 13px;
  //   color: rgba(0, 0, 0, 0.5);
  // }
}

.inputBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // outline: 1px solid red;
  color: rgba(0, 0, 0, 0.8);
  margin: 5px 5px;
  padding: 2px 5px;
  .container {
    outline: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    //  height: 30px;
    padding: 0px 6px;
  }
  .submit {
    margin-left: 5px;
    font-size: 14px;
    outline: 1px solid rgba(0, 0, 0, 0.3);
    padding: 6px 5px;
    border-radius: 4px;
  }
}
.inputEmail {
  width: 190px;

  // border: 1px solid red;
}
.checkbox2 {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.subscribeDetails2 {
  padding: 20px;
  border: 1px solid rgba(247, 149, 31, 0.1);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 2px 0px;
  border-collapse: separate;
  background: rgba(247, 149, 31, 0.05);

  .row {
    margin-top: 10px;
  }
}

.unread1 {
  position: absolute;
  display: inline-block;
  // outline: 1px solid red;
  width: 20px;
  line-height: 20px;
  top: -6px;
  left: 260px;
  border-radius: 50%;
  text-align: center;
  font-size: 10px;
  color: aliceblue;
  background: #ea6767;
  z-index: -1;
}
::v-deep .ql-editor {

  /* 样式穿透 */

  min-height: 180px !important;

}
::v-deep .el-form-item__content{
  margin-left:  0px !important;
}
</style>
<style >
.period .el-select .el-input__inner {
  width: 100%;
  /* background: red; */
  border: none;
  outline: none;
  margin-top: 0px !important;
  height: 28px;
}



</style>